export const name: string = 'Pivot Grid';
export const group = 'Charting';
export const moduleName: string = 'pdc-widget-pivot';
export const icon: string = 'list-alt';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-pivot'; //VR: Theme ID (to SELECT and EXPAND it in Theme dialog)

export const themeFields = {
    treeRowHeaderLayout: 'tree-row-header-layout',
    headerFrontColor: 'widget-pivot-hd-color',
    rowColor:'widget-pivot-row-color',
    headerBGColor: 'widget-pivot-hdbg-color',
    grandtotalBGColor: 'widget-pivot-rowsum-color',
    rowBgColor: 'widget-pivot-rowbg-color',
    bottomBgColor: 'widget-pivot-bg-color',
    alignment: 'widget-pivot-alignment',
    headerAlignment: 'widget-pivot-row-header-alignment'
};